import { styled } from "@mui/material";

export const KeyValueContent = styled("span")({
  fontWeight: 300,
});
